export default __webpack_public_path__ + "static/media/Pregacap-50-ban.ddf4ae32.jpg";